import { TextField } from '@mui/material'
import React, { FC } from 'react'

import { FormData } from './InsertTableDialog'
import { FormValidationError } from './validation'

interface FormFieldProps {
  onChange: (value: string, key: keyof FormData) => void
  value: string
  fieldKey: keyof FormData
  placeholder: string
  label: string
  error: FormValidationError
}

/**
 * Reusable text field component for insert table dialog
 */
export const FormField: FC<FormFieldProps> = ({ fieldKey, onChange, value, label, placeholder, error }) => {
  return (
    <TextField
      label={label}
      placeholder={placeholder}
      onChange={e => {
        onChange(e.target.value, fieldKey)
      }}
      value={value}
      error={error?.path === fieldKey}
      helperText={error?.path === fieldKey && error.message}
      type={'number'}
      key={fieldKey}
    />
  )
}
